import React from 'react';

import RegistrationWrapper from 'common/canny/register/RegistrationWrapper';
import SingleSelect from 'common/ui/SingleSelect';
import VStack from 'common/ui/VStack';

import AdminOnboardingFieldLabel from './AdminOnboardingFieldLabel';
import AdminOnboardingMultiSelect from './AdminOnboardingMultiSelect';
import { companySizeOptions, roleOptions, teamOptions } from './data';

import type { UseCase } from './Types';
import type { Option } from 'common/ui/common/select/SelectCommon';

type Props = {
  onChange: (useCase: UseCase) => void;
  useCase: UseCase;
};

const AdminOnboardingTeam = ({ onChange, useCase }: Props) => {
  const onChangeCompanySize = (option?: Option) => {
    onChange({
      ...useCase,
      companySize: option?.value || null,
    });
  };

  const onChangeRole = (option?: Option) => {
    onChange({
      ...useCase,
      role: option?.value || null,
    });
  };

  const onChangeTeams = (teams: string[]) => {
    onChange({
      ...useCase,
      teams,
    });
  };

  const getCompanySizeValue = (): Option | undefined => {
    if (!useCase.companySize) {
      return undefined;
    }
    return companySizeOptions.find((option) => option.value === useCase.companySize) || undefined;
  };

  const getRoleValue = (): Option | undefined => {
    if (!useCase.role) {
      return undefined;
    }
    return roleOptions.find((option) => option.value === useCase.role) || undefined;
  };

  return (
    <RegistrationWrapper.Content>
      <RegistrationWrapper.Header>
        <RegistrationWrapper.Title>Tell us about your team</RegistrationWrapper.Title>
        <RegistrationWrapper.Description>
          This helps us tailor your experience and give you more relevant tips
        </RegistrationWrapper.Description>
      </RegistrationWrapper.Header>
      <VStack className="gap-7">
        <VStack className="gap-2">
          <AdminOnboardingFieldLabel>
            How many people work at your company?
          </AdminOnboardingFieldLabel>
          <SingleSelect
            onChange={onChangeCompanySize}
            options={companySizeOptions}
            placeholder="Choose a size"
            className="max-w-[260px]"
            value={getCompanySizeValue()}
          />
        </VStack>
        <VStack className="gap-2">
          <AdminOnboardingFieldLabel>What is your role?</AdminOnboardingFieldLabel>
          <SingleSelect
            onChange={onChangeRole}
            options={roleOptions}
            placeholder="Choose a role"
            className="max-w-[260px]"
            value={getRoleValue()}
          />
        </VStack>
        <VStack className="gap-2">
          <AdminOnboardingFieldLabel>Which teams will be using Canny?</AdminOnboardingFieldLabel>
          <AdminOnboardingMultiSelect
            onChange={onChangeTeams}
            options={teamOptions}
            selected={useCase.teams || []}
          />
        </VStack>
      </VStack>
    </RegistrationWrapper.Content>
  );
};

export default AdminOnboardingTeam;
